module.exports = __webpack_public_path__ + "static/img/big_logo.3d40294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/big_logo.png
// module id = PqZ5
// module chunks = 22